// VideoPage.js
import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import "./AnalyticsPage.css";
import { baseURL } from "../Constant";
// const baseURL =
//   "https://atci.entrylevellearning.accenture.com/techexpress-apis";

const VideoPage = () => {
  const [data, setData] = useState([]);
  const videoRef = useRef(null);
  const viewTracked = useRef(false);
  const [initialTime, setInitialTime] = useState(0);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";

  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const lkmPagesAnalytics = () => {
    axios
      .post(
        `${baseURL}/analyticsvideouser`,
        {
          enterprise_id: loggedInEnterpriseId,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        getAnalytics();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAnalytics = () => {
    axios
      .get(`${baseURL}/analyticsvideo`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        // setTotalViews(response.data.totalViews);
        // setTotalUserViews(response.data.totalUniqueUsers);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getAnalytics();
  }, []);
  // Restore paused video state from sessionStorage (only survives page-to-page, not full refresh)
  useEffect(() => {
    const savedTime = sessionStorage.getItem("videoTime");
    if (savedTime) {
      setInitialTime(parseFloat(savedTime));
    }
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (video && initialTime > 0) {
      video.currentTime = initialTime;
    }
  }, [initialTime]);

  // Save video time on pause or navigation
  const handlePauseOrTimeUpdate = () => {
    const video = videoRef.current;
    if (video) {
      sessionStorage.setItem("videoTime", video.currentTime);
    }

    // Track 25% watch only once
    if (!viewTracked.current) {
      const percentageWatched = (video.currentTime / video.duration) * 100;
      if (percentageWatched >= 25) {
        viewTracked.current = true;
        lkmPagesAnalytics();
      }
    }
  };

  const handlePlay = () => {
    if (videoRef.current?.currentTime === 0) {
      viewTracked.current = false;
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <video
        width="500"
        id="kmsembed-1_bq8239bi"
        controls
        ref={videoRef}
        onTimeUpdate={handlePauseOrTimeUpdate}
        onPause={handlePauseOrTimeUpdate}
        onPlay={handlePlay}
      >
        <source src="/images/EntryLevel.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPage;
